import React, { Component } from 'react';
import { connect } from 'react-redux';

import { normalizeCurrencyValue } from '../../../../utils/ddny';

import LoadingIcon from '../../../common/icons/LoadingIcon';
import RhinoModal from '../../../common/modal/RhinoModal';

import styles from './_styles/EditModalElement.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class EditModalElement extends Component {

	constructor(props) {
	
		super(props);
	
		this.state = {

			modalOpen: false,

			variantInputs: {},
			variantErrors: {},

			requestPending: false,
		};

		this.handleKeypressMethod = this.handleKeypress.bind(this);
	}

	componentDidMount() {
		window.addEventListener('keydown', this.handleKeypressMethod);
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.handleKeypressMethod);
	}

	handleKeypress(evt) {
		if ((evt.key === 'Enter' || evt.keyCode === 13) && this.state.modalOpen) {
			evt.preventDefault();          // stop the browser’s default form-submit
			this.handleSubmit();         // call your own submit logic
		}
	}
	
	formatOptions() {
		const attrs = this.props.attributeOptions || [];
		return attrs.map(attr => {
			return {
				display: attr.name,
				value: attr.data_key,
			}
		});
	}

	handleChange(evt) {
		// Returns (typeKey, attrValue)
		switch(this.props.fieldSchema?.type) {
			case 'toggle':
				this.props.onChange(this.props.fieldSchema?.stateKey, !this.props.value);
				break;
			default:
				const val = this.props.fieldSchema?.formatOnChange 
					? this.props.fieldSchema.formatOnChange(evt.target.value) 
					: evt.target.value;
				this.props.onChange(this.props.fieldSchema?.stateKey, val);
		}
	}

	formatRange(variants, dataKey, formatMethod = null) {
		
		const values = variants
			.map(val => parseFloat(val[dataKey]))
			.filter(num => !Number.isNaN(num));

		if(values.length === 0) {
			return '';
		}

		const min = Math.min(...values);
		const max = Math.max(...values);

		if(min === max) {
			return formatMethod ? formatMethod(min) : min;
		} else {
			return `${formatMethod ? formatMethod(min) : min} - ${formatMethod ? formatMethod(max) : max}`;
		}
	}

	formatVariantValues() {
		
		const dataKey = this.props.fieldSchema?.apiKey;
		const respData = {};
		const labels = [
			'14k', '18k', 'Platinum'
		];

		if(!dataKey || !this.props.product) {
			return null;
		}

		// If using API and loading, say so
		if(this.props.fieldSchema?.useApiData && this.props.apiDataPending) {
			return <div className={styles.variantNotice}>Checking ASC data</div>
		}

		// If using API and has data, say so
		if(this.props.fieldSchema?.useApiData && this.props.apiData) {
			return <div className={styles.variantNotice}>Pricing data set by ASC</div>
		}
		
		// If no variants, say so
		if(!this.props.product.variants || this.props.product.variants.length === 0) {
			return <div className={styles.variantNotice}>{`No product variants to set ${this.props.fieldSchema?.dataLabel || this.props.fieldSchema?.apiKey}`}</div>
		}

		// Sort standard variants
		for(const label of labels) {
			
			let variants = [];

			if(label === '14k') {
				variants = this.props.product?.variants.filter(el => el.gold_weight.toLowerCase() === label.toLowerCase());
			} else if(label === '18k') {
				variants = this.props.product?.variants.filter(el => el.gold_weight.toLowerCase() === label.toLowerCase());
			} else if(label === 'Platinum') {
				variants = this.props.product?.variants.filter(el => el.gold_color.toLowerCase() === label.toLowerCase());
			}

			if(variants.length > 0) {
				const rangeValue = this.formatRange(variants, dataKey, this.props.fieldSchema?.formatOnDisplay);
				if(rangeValue) {
					respData[label] = rangeValue;
				}
			}
		}

		// Sort user-entered variants
		const nonStandardVariants = this.props.product?.variants.filter(el => !['14k', '18k'].includes(el.gold_weight.toLowerCase()) && el.gold_color.toLowerCase() !== 'platinum');
		const uniqueSortedWeights = [
			...new Set(
				nonStandardVariants
				.map(v => v.gold_weight)
				.filter(w => typeof w === 'string' && w.trim() !== '')
			)
		].sort((a, b) =>
			a.localeCompare(b, undefined, { sensitivity: 'base' })
		);

		for(const label of uniqueSortedWeights) {
			const variants = this.props.product?.variants.filter(el => el.gold_weight === label);
			if(variants.length > 0) {
				const rangeValue = this.formatRange(variants, dataKey, this.props.fieldSchema?.formatOnDisplay);
				if(rangeValue) {
					respData[label] = rangeValue;
				}
			}
		}

		if(Object.keys(respData).length === 0) {
			return null;
		}

		return <div className={styles.variantValues}>
			{Object.keys(respData).map((key, i) => {

				if(!respData[key]) {
					return null;
				}

				return <div className={styles.variantRow} key={i}>
					<div className={styles.rowLabel}>{key}</div>
					<div className={styles.rowValue}>{respData[key]}</div>
				</div>
			})}
		</div>
	}

	getOrderedVariants() {
		if(!this.props.product?.variants) { return []; }
		
		const sortedVariants = this.props.product.variants
			.slice() // copy so we don’t mutate props
			.sort((a, b) => {
				// normalize and detect empties
				const wa = a.gold_weight  == null || a.gold_weight  === '' 
						? null 
						: a.gold_weight.toString().toLowerCase();
				const wb = b.gold_weight  == null || b.gold_weight  === '' 
						? null 
						: b.gold_weight.toString().toLowerCase();

				// 1) any “empty” goes last
				if (wa === null && wb !== null) return  1;
				if (wa !== null && wb === null) return -1;

				// 2) both non-empty? compare ascending
				if (wa !== null && wb !== null) {
				const wcmp = wa.localeCompare(wb, undefined, { sensitivity: 'base' });
				if (wcmp !== 0) return wcmp;
				}

				// 3) tie or both empty: compare color descending
				const ca = (a.gold_color  || '').toString().toLowerCase();
				const cb = (b.gold_color  || '').toString().toLowerCase();
				return cb.localeCompare(ca, undefined, { sensitivity: 'base' });
			});
		
		return sortedVariants;
	}

	toggleModal() {
		this.setState({ modalOpen: !this.state.modalOpen });
	}

	async handleSubmit(evt) {
		if(evt) { evt.preventDefault(); }

		this.setState({ requestPending: true });

		try {

			// Make edit requests
			const requestArray = [];
			for(const varId in this.state.variantInputs) {
				const reqData = { 
					[this.props.fieldSchema.apiKey]: this.state.variantInputs[varId] || null,
				};
				requestArray.push(this.props.ddnyUpdateVariant(reqData, varId));
			}

			await Promise.all(requestArray);

			await this.props.refresh({ showLoading: false });

			this.toggleModal();

		} catch(err) {
			console.error(err);
		} finally {
			this.setState({ requestPending: false });
		}
	}

	variantValue(variant) {
		if(!variant?.id) {
			return '';
		} else if(this.state.variantInputs[variant.id] || this.state.variantInputs[variant.id] === '') {
			// If edited, return value
			return this.state.variantInputs[variant.id];
		} else {
			// Otherwise, return current value
			const found = this.props.product?.variants.find(v => v.id === variant.id);
			return found && found[this.props.fieldSchema.apiKey] ? found[this.props.fieldSchema.apiKey] : '';
		}
	}

	changeVariantValue(evt, variant) {
		this.setState({
			variantInputs: { ...this.state.variantInputs, [variant.id]: evt.target.value }
		}, () => {
			if(this.state.variantErrors[variant.id]) {
				this.validateVariantValue(evt, variant);
			}
		});
	}

	validateVariantValue(evt, variant) {
		if(evt) { evt.preventDefault(); }

		const val = evt.target.value;

		if(val === '') {
			this.setState({
				variantErrors: { ...this.state.variantErrors, [variant.id]: null }
			});
		} else if(parseFloat(val)) {
			this.setState({
				variantInputs: { ...this.state.variantInputs, [variant.id]: normalizeCurrencyValue(val) }
			});
		} else {
			this.setState({
				variantErrors: { ...this.state.variantErrors, [variant.id]: 'Please enter a valid value' }
			});
		}
	}
	
	render() {
		return <div className={styles.EditModalElement}>
			<div className={styles.elemWrapper}>
				<div className={`${styles.label} EllipsisElement`}>{this.props.fieldSchema?.label || ''}</div>
				<div className={styles.displayWrapper}>
					{this.formatVariantValues()}
				</div>
				<div className={styles.linkWrapper}>
					{(!this.props.fieldSchema?.useApiData || (!this.props.apiData && !this.props.apiDataPending)) && (
						<div className={styles.link} onClick={this.toggleModal.bind(this)}>Edit</div>
					)}
				</div>
			</div>
			<RhinoModal
        		open={this.state.modalOpen}>
				<div className={styles.modalWrapper}>
					<div className={styles.modalClose} onClick={this.toggleModal.bind(this)}>&times;</div>
					<div className={styles.modalTitle}>Edit {this.props.fieldSchema?.label}</div>
					<div className={styles.variantsForm}>
						{this.getOrderedVariants().length === 0
							? 	<div className={styles.noVariants}>No product variants</div>
							:	<div className={styles.variantList}>
									<div className={styles.titleRow}>
										<div className={styles.label}>Variant</div>
										<div className={styles.input}>{this.props.fieldSchema?.label}</div>
									</div>
									{this.getOrderedVariants().map((variant, i) => {
										return <div key={i} className={styles.variantRow}>
											<div className={styles.labelWrapper}>
												<div className={styles.label}>
													{`${variant.gold_weight ? `${variant.gold_weight} ` : ''}${variant.gold_color}`}
												</div>
											</div>
											<div className={styles.inputWrapper}>
												<input 
													type='text'
													className={this.state.variantErrors[variant.id] ? styles.error : ''}
													value={this.variantValue(variant)}
													onChange={(evt) => this.changeVariantValue(evt, variant)}
													onBlur={(evt) => this.validateVariantValue(evt, variant)} />
											</div>
										</div>
									})}
								</div>
						}
					</div>
					<div className={styles.actionsWrapper}>
						<button
							type='button'
							className={`${styles.action} secondaryButton`}
							disabled={this.state.requestPending}
							onClick={this.toggleModal.bind(this)}>
							Cancel
						</button>
						<button
							type='button'
							className={`${styles.action} actionButton`}
							disabled={this.state.requestPending || Object.values(this.state.variantErrors).some(err => err != null)}
							onClick={this.handleSubmit.bind(this)}>
							Save
						</button>
					</div>
					{this.state.requestPending && (
						<div className={styles.loadingWrapper}>
							<div className={styles.iconWrapper}>
								<LoadingIcon />
							</div>
						</div>
					)}
				</div>
			</RhinoModal>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(EditModalElement);